import {
  IsBoolean,
  IsEmail,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  MaxLength,
} from "class-validator";
import Spec from "constants/Spec";
import { DataValidationError } from "constants/DataValidationError";
import { CastExaminationType } from "types/enum/CastExaminationType";

export default class CreateCompanyReq {
  @IsNotEmpty({
    message: "",
  })
  companyGroupId: number;
  @MaxLength(Spec.maxLength.company.name, {
    message: "",
    context: {
      constraint1: Spec.maxLength.company.name,
    },
  })
  @IsNotEmpty({ message: "" })
  name!: string;

  @MaxLength(Spec.maxLength.company.kana, {
    message: "",
    context: {
      constraint1: Spec.maxLength.company.kana,
    },
  })
  @IsNotEmpty({ message: "" })
  kana!: string;

  @MaxLength(Spec.maxLength.company.email, {
    message: "",
    context: {
      constraint1: Spec.maxLength.company.email,
    },
  })
  @IsNotEmpty({ message: "" })
  @IsEmail()
  email!: string;

  @MaxLength(Spec.maxLength.company.tel, {
    message: "",
    context: {
      constraint1: Spec.maxLength.company.tel,
    },
  })
  @IsNotEmpty({ message: "" })
  tel!: string;

  @MaxLength(Spec.maxLength.company.representativeName, {
    message: "",
    context: {
      constraint1: Spec.maxLength.company.representativeName,
    },
  })
  @IsNotEmpty({ message: "" })
  representativeName!: string;

  @IsNotEmpty({ message: "" })
  @IsBoolean()
  isCallCenterContract!: boolean;

  @IsBoolean()
  pointShopFlag!: boolean;

  @IsBoolean()
  guestCategoryShopFlag!: boolean;

  @IsOptional()
  @IsNumber()
  sort!: number | null;

  @IsOptional()
  castExaminationType: CastExaminationType | null = null;

  @IsOptional()
  @IsNumber()
  castExaminationCount: number | null = null;

  @IsNotEmpty({ message: DataValidationError.DATA_IS_EMPTY })
  changeDateTime!: string;

  // #473: URL 短縮 SMS 利用可否 (会社単位)
  @IsOptional()
  @IsBoolean()
  urlPageSmsEnabled = false;

  constructor(arg: any) {
    arg = arg || {};
    this.companyGroupId = arg.companyGroupId;
    this.name = arg.name;
    this.kana = arg.kana;
    this.email = arg.email;
    this.tel = arg.tel;
    this.representativeName = arg.representativeName;
    this.isCallCenterContract = arg.isCallCenterContract;
    this.pointShopFlag = arg.pointShopFlag;
    this.guestCategoryShopFlag = arg.guestCategoryShopFlag;
    this.sort = arg.sort;
    this.castExaminationType = arg.castExaminationType;
    this.castExaminationCount = arg.castExaminationCount;
    this.changeDateTime = arg.changeDateTime;
    this.urlPageSmsEnabled = arg.urlPageSmsEnabled ?? false;
  }
}
